import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
import { UsersCard } from '../../component/Card/Statistics.card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faRefresh, faUser, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { ClientService } from '../../component/services/client.service';
import toast from 'react-hot-toast';
import { makeParams } from '../../component/api/makeRequest';
import DataTable from '../../component/table/Invigilator.table';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import moment from 'moment';
import TablePaginationComponent from '../../component/table/TablePagination';
import StatsCard from '../../component/Cards/StatsCard';

export default function FacialMisMatchData() {
    const [tableData, setTableData] = useState<any[]>([]);
    const [centers, setCenters] = useState<any>([]);
    const [selectedCenters, setSelectedCenters] = useState<any>([]);
    const [shifts, setShifts] = useState<any>([]);
    const [selectedShift, setSelectedShift] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const [distinctCount, setDistinctCount] = useState<number>(0);


    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<any>(10);
    const [totalCount, setTotalCount] = useState<number>(0);

    const dropDownOptions = [
        { label: "Yes", value: 'true' },
        { label: "No", value: 'false' },
    ];

    const [selectedOption, setSelectedOption] = useState<any>({ value: 'true', label: "Yes" });


    const getUniqueCenter = async () => {
        try {
            const res = await ClientService.getUniqueCenter2(selectedShift);
            if (res.status === 200) {
                setCenters(
                    res.data?.centers.map((zone: any) => ({
                        value: zone?.centerPreference,
                        label: zone?.allocatedCenterId + " - " + zone?.centerPreference,
                    }))
                );
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch centers');
        }
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getStats = async () => {
        const payload = {
            centerId: selectedCenters?.map((data: any) => data?.value),
            manuallyVerified: selectedOption?.value,
        }
        setLoading(true);
        try {
            const res = await ClientService.getFacialMismatchData(selectedShift, pageSize, pageNumber, payload);
            if (res.status === 200) {
                setTableData(res.data?.data?.verifications || []);
                setTotalCount(res.data?.data?.verifications_count || 0);
                setDistinctCount(res.data?.data?.verifications_distinct || 0)
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch stats');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedShift) {
            getStats();
        }
    }, [selectedCenters, selectedOption, pageNumber, pageSize]);

    useEffect(() => {
        if (selectedShift) {
            getUniqueCenter();
        }
    }, [selectedShift]);

    useEffect(() => {
        getAllShift();
    }, []);

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 className="text-secondary">Facial Verification Data</h4>
                </Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectedShift(e?.value)}
                        isClearable
                        value={selectedShift ? shifts.find((shift: any) => shift.value === selectedShift.value) : null}
                    />
                </Col>
            </Row>

              <Row className="mt-3">
                                        <Col md={3}>
                                            <StatsCard
                                                title="Total"
                                                value={totalCount || 0}
                                                icon={faUser}
                                                iconColor="success"
                                                valueColor="success"
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <StatsCard
                                                title="Distinct Students"
                                                value={distinctCount || 0}
                                                icon={faUserCheck}
                                                iconColor="success"
                                                valueColor="success"
                                            />
                                        </Col>
                                    </Row>
            
            <Card className="mt-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '12px', border: 'none' }}>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="text-muted fw-bold">Venue</Form.Label>
                                <Select
                                    options={[{ label: 'All', value: 'All' }, ...(centers || [])]}
                                    onChange={(selectedOptions: any) => {
                                        if (selectedOptions?.some((option: any) => option.value === 'All')) {
                                            setSelectedCenters(centers);
                                        } else {
                                            setSelectedCenters(selectedOptions || []);
                                        }
                                    }}
                                    value={selectedCenters}
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className="text-muted fw-bold">
                                    Manually Verified
                                </Form.Label>
                                <Select
                                    options={dropDownOptions}
                                    onChange={(selectedOption: any) => {
                                        setSelectedOption(selectedOption);
                                    }}
                                    value={selectedOption}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                // isClearable
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Row className="mt-4">
                <Card
                    className="mt-3"
                    style={{
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        border: "none",
                    }}
                >
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-end">
                            <Button size="sm" onClick={getStats} disabled={loading || !selectedShift || !selectedCenters.length} variant='outline-secondary'>
                                <FontAwesomeIcon icon={faRefresh} /> Reload
                            </Button>
                        </div>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: 14 }}>#</th>
                                    <th style={{ fontSize: 14 }}>Name</th>
                                    <th style={{ fontSize: 14 }}>Roll No</th>
                                    <th style={{ fontSize: 14 }}>Exam</th>
                                    <th style={{ fontSize: 14 }}>State</th>
                                    <th style={{ fontSize: 14 }}>Zone</th>
                                    <th style={{ fontSize: 14 }}>City</th>
                                    <th style={{ fontSize: 14 }}>Venue Id</th>
                                    <th style={{ fontSize: 14 }}>Facial Manually Verified</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ? (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </td>
                                        </tr>
                                    ) :
                                        tableData?.length > 0 ? (
                                            tableData.map((item: any, index: number) => (
                                                <tr key={item?._id}>
                                                    <td style={{ fontSize: 12 }}>
                                                        {index + 1 + (pageNumber - 1) * pageSize}
                                                    </td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.name}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.rollNo}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.courseName}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.state}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.zone}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.city}</td>
                                                    <td style={{ fontSize: 12 }}>{item?.studentId?.centerPreference}</td>
                                                    <td style={{ fontSize: 12 }}>
                                                        {
                                                            item?.verificationDetails?.find((detail: any) => detail?.method === 'facial')?.manuallyVerified
                                                                ? 'Yes'
                                                                : 'No'
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center">
                                                    No Data Available
                                                </td>
                                            </tr>
                                        )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Row>

            <Row>
                <Col>
                    <TablePaginationComponent
                        currentPage={pageNumber}
                        itemsCount={totalCount}
                        itemsPerPage={pageSize}
                        setItemsPerPage={(e: any) => setPageSize(e)}
                        setCurrentPage={setPageNumber}
                    />
                </Col>
            </Row>
        </>
    );
};